import React, { Fragment, useEffect, useState } from 'react'
import TextQuestion from './components/TextQuestion'
import RadioSelectQuestion from './components/RadioSelectQuestion'
import FileQuestion from './components/FileQuestion'
import MultiSelectQuestion from './components/MultiSelectQuestion'
import ReadonlyTextBlock from './components/ReadonlyTextBlock'
import NumberQuestion from './components/NumberQuestion'
import DateQuestion from './components/DateQuestion'
import GroupedQuestion from './components/GroupedQuestion'
import TFQuestion from './components/TFQuestion'
import { Field } from 'redux-form'
import Grid from '@material-ui/core/Grid'
import CircularProgress from '@material-ui/core/CircularProgress'
import { required, date } from '../../../utilties/validators'
import AnalogQuestion from './components/AnalogQuestion'
import { evalRule, categoryCode, questionCode, answerCode, questionValue } from '../../../utilties/utilities'
import { Typography } from '@material-ui/core'
import BilateralQuestionInfo from './BilateralQuestionInfo'
import { setUploadingCount, stopSaving } from '../../../redux/actions'
import { useDispatch } from 'react-redux'


const DEFAULT_VISIBILITY_DELAY = 2000

var _regexValidationMessages = {}

const requiredValidator = required
const dateValidator = date
const regexValidator = (
	value,
	allValues,
	props,
	name
) => {
	if (value) {
		try {
			if (!new RegExp(_regexValidationMessages[name].value).test(value))
				return _regexValidationMessages[name].message;
		}
		catch {

		}
	}

	return undefined;
}

const DelayedQuestionContainer = ({
	container,
	...rest
}) => {
	const [rootStyle, setRootStyle] = useState({})
	const [questionStyle, setQuestionStyle] = useState({})
	const [showLoading, setShowLoading] = useState(false)
	const [isBilateral, setIsBilateral] = useState(false)
	const [isConditionalVisibility, setIsConditionalVisibility] = useState(false)

	useEffect(
		() => {
			resetRootContainerVisiblity()
		},
		[]
	)	
	
	useEffect(
		() => {
			if(isConditionalVisibility) {
				setShowLoading(true)
				let intervalId = setTimeout(
					() => {
						clearTimeout(intervalId)
						setShowLoading(false)
					},
					1000
				)
			}
		},
		[isConditionalVisibility]
	)

	useEffect(
		() => {
			Object.keys(rest).map((key, index) => {
				const question = rest[key]

				if (index === 0) {
					setIsBilateral(question.isBilateral)
				}

				if(question.visibilityRule)
				{
					setIsConditionalVisibility(true)
				}
			})
		},
		[rest]
	)

	useEffect(
		() => {
			setQuestionStyle(
				{
					height: !showLoading ? undefined : '60px',
					opacity: !showLoading ? 1 : 0,
					transition: !showLoading ? 'opacity 1s, visibility 0s linear 0.3s' : undefined
				}
			)
			resetRootContainerVisiblity()
		},
		[showLoading]
	)

	const resetRootContainerVisiblity = () => {
		setRootStyle(
			{
				marginTop: "0",
				marginBottom: isBilateral ? "0" : showLoading === 0 ? '0' : '0',
				position: 'relative'
			}
		)
	}

	return (
		<div className={isBilateral ? 'bilateral-survey' : 'standart-survey'}
			style={rootStyle}
		>
			<div className={isBilateral ? 'bilateral-survey-inner' : 'standart-survey-inner'}
				style={questionStyle}
			>
				{
					container
				}
			</div>
			{
				!!showLoading
				&& <div
					container
					style={{
						position: 'absolute',
						top: '50%',
						left: '50%',
						transform: 'translateY(-50%) translateX(-50%)'
					}}
				>
					<CircularProgress />
				</div>
			}
		</div>
	)
}
	
const getQuestionDefaultEvalContext = (instanceId, question) => {
	let result = ""

	if (question.questionType !== 8) {
		if (!!question.answers) {
			let values = []
			question.answers.map((answer) => {
				result += `let ${answerCode(question.id, answer.id)}=null\r\n`
			})

			result += `let ${questionCode(instanceId, question.id, question.questionType)}=[${values.join(",")}]\r\n`
		}
		else if (!!question.categories) {
			question.categories.map((category) => {
				result += `let ${categoryCode(question.id, category.id)}=null\r\n`
			})
		}
		else {
			result += `let ${questionCode(instanceId, question.id, question.questionType)}=null\r\n`
		}
	}

	return result
}

const getQuestionEvalContext = (instanceId, question) => {
	let result = ""

	if (question.questionType !== 8) {
		if (!!question.answers) {
			let values = []
			question.answers.map((answer) => {
				if (!!answer.checked) {
					result += `let ${answerCode(question.id, answer.id)}=${answer.id}\r\n`
					values.push(`${answer.id}`)
				}
				else {
					result += `let ${answerCode(question.id, answer.id)}=null\r\n`
				}
			})
			result += `let ${questionCode(instanceId, question.id, question.questionType)}=[${values.join(",")}]\r\n`
		}
		else if (!!question.categories) {
			question.categories.map((category) => {
				if (!!category.value) {
					result += `let ${categoryCode(question.id, category.id)}=${questionValue(question.questionType, category.value)}\r\n`
				}
				else {
					result += `let ${categoryCode(question.id, category.id)}=null\r\n`
				}
			})
		}
		else {
			result += `let ${questionCode(instanceId, question.id, question.questionType)}=${questionValue(question.questionType, question.value)}\r\n`
		}
	}

	return result
}

const onQuestionValueChanged = (instanceId, onQuestionChanged, question, value, answer, category) => {
	question.changed = true
	if (!!answer) {
		answer.checked = value
	}
	else if (!!category) {
		category.value = value
	}
	// else if ([10, 11].includes(question.questionType)) {
	// 	question.url = value
	// }
	else {
		question.value = value
	}
	
	if (question.childVisibilityRefs.length > 0 || question.childOptionalRefs.length > 0) {
		question.context = getQuestionEvalContext(instanceId, question)

		let interval = setInterval(
			() => {
				clearInterval(interval)
				onQuestionChanged(question)
			},
			300
		)
	}
}

const createValidators = (question) => {
	let result = []

	if (question.isVisible) {
		if (!!question.regularExpression) {
			result.push(regexValidator);
		}

		if (!question.isOptional) {
			result.push(requiredValidator)
		}
	}

	return result
}

const renderQuestions = (
	collection,
	lists,
	instanceId,
	isBilateral,
	bilateralAreas,
	questionChanged,
	readonly
) => {
	if (!!lists) {
		var rendered = new Array()
		var counter = 0
		var displayCount = 0

		let isBilateralAreaNamesRendered = false
		let renderBilateralAreaNames = false

		collection.map(nodes => {
			let node = nodes[0]

			if(!node.data.isVisible && (!nodes[1] || !nodes[1].data?.isVisible)) {
				return
			}

			counter++
			if (node.data.questionType !== 8) {
				displayCount++
			}

			let questionAboutToRender = null

			const isBilateralQuestion = !!isBilateral && !!node.data.isBilateral

			let isVisibleNodes = false

			nodes.map(node => {
				if (node.data.isVisible) {
					isVisibleNodes = true
				}
			})

			if (!isVisibleNodes) {
				return
			}

			if (
				node.data.questionType != 8
				&& isBilateralQuestion
			) {
				if (node.data.questionType == 3) {
					renderBilateralAreaNames = true
				}
				else if (!isBilateralAreaNamesRendered) {
					renderBilateralAreaNames = true
				}
			}
			else {
				isBilateralAreaNamesRendered = false
				renderBilateralAreaNames = false
			}

			const getQuestionGridSize = (isBilateral, index) => (!isBilateral ? 12 : index === 0 ? 6 : 6)
			const getIsBilateralFullInfo = (isBilateral, index) => (!!isBilateral && index === 0)
			const getBorderLeft = (isBilateral, index) => (index > 0 ? "2px solid #ededf1" : "none")
			const getPadding = (isBilateral, index) => (isBilateral && index == 0 ? "0" : "0")

			switch (node.data.questionType) {
				case 6:
					questionAboutToRender = (
						nodes.map((node, index) => {
							const validators = createValidators(node.data)

							return (
								<Grid
									item
									xs={getQuestionGridSize(isBilateralQuestion, index)}
									className={isBilateralQuestion ? 'bilateral-grid' : ''}
									style={{
										borderLeft: getBorderLeft(isBilateralQuestion, index),
										padding: getPadding(isBilateralQuestion, index)
									}}
								>
									<NumberQuestion
										data-testid="survey-container-answers-number"
										isFilled={true}
										question={node.data}
										position={counter}
										key={node.data.uniqueId}
										positionDisplay={displayCount}
										validate={validators}
										disabled={readonly || !node.data.isVisible}
										isBilateral={isBilateralQuestion}
										displayInstructionAsIcon={node.data.displayInstructionAsIcon}
										isBilateralFullInfo={getIsBilateralFullInfo(isBilateralQuestion, index)}
										uniqueKey={index}
										onQuestionValueChanged={(question, value, answer, category) => onQuestionValueChanged(instanceId, questionChanged, question, value, answer, category)}
									/>
								</Grid>
							)
						})
					)
					break
				case 5:
					questionAboutToRender = (
						nodes.map((node, index) => {
							const validators = createValidators(node.data)

							return (
								<Grid
									item
									xs={getQuestionGridSize(isBilateralQuestion, index)}
									className={isBilateralQuestion ? 'bilateral-grid' : ''}
									style={{
										borderLeft: getBorderLeft(isBilateralQuestion, index),
										padding: getPadding(isBilateralQuestion, index)
									}}
								>
									<Field
										data-testid="survey-container-answers-text"
										name={`answers.text._${node.data.uniqueId}._${index}`}
										component={TextQuestion}
										question={node.data}
										position={counter}
										key={node.data.uniqueId}
										positionDisplay={displayCount}
										validate={validators}
										disabled={readonly || !node.data.isVisible}
										isBilateral={isBilateralQuestion}
										displayInstructionAsIcon={node.data.displayInstructionAsIcon}
										isBilateralFullInfo={getIsBilateralFullInfo(isBilateralQuestion, index)}
										onChange={(e) => onQuestionValueChanged(instanceId, questionChanged, node.data, e.target.value, undefined, undefined)}
										onQuestionValueChanged={(question, value, answer, category) => onQuestionValueChanged(instanceId, questionChanged, question, value, answer, category)}
									/>
								</Grid>
							)
						})
					)
					break

				case 7:
					questionAboutToRender = (
						nodes.map((node, index) => {
							const validators = createValidators(node.data)

							return (
								<Grid
									item
									xs={getQuestionGridSize(isBilateralQuestion, index)}
									className={isBilateralQuestion ? 'bilateral-grid' : ''}
									style={{
										borderLeft: getBorderLeft(isBilateralQuestion, index),
										padding: getPadding(isBilateralQuestion, index)
									}}
								>
									<DateQuestion
										data-testid="survey-container-answers-date"
										question={node.data}
										position={counter}
										key={node.data.uniqueId}
										positionDisplay={displayCount}
										validators={validators}
										disabled={readonly || !node.data.isVisible}
										isBilateral={isBilateralQuestion}
										displayInstructionAsIcon={node.data.displayInstructionAsIcon}
										isBilateralFullInfo={getIsBilateralFullInfo(isBilateralQuestion, index)}
										uniqueKey={index}
										onQuestionValueChanged={(question, value, answer, category) => onQuestionValueChanged(instanceId, questionChanged, question, value, answer, category)}
									/>
								</Grid>
							)
						})
					)
					break
				case 2:
					questionAboutToRender = (
						nodes.map((node, index) => (
							<Grid
								item
								xs={getQuestionGridSize(isBilateralQuestion, index)}
								className={isBilateralQuestion ? 'bilateral-grid' : ''}
								style={{
									borderLeft: getBorderLeft(isBilateralQuestion, index),
									padding: getPadding(isBilateralQuestion, index)
								}}
							>
								<MultiSelectQuestion
									data-testid="survey-container-multi-select"
									question={node.data}
									position={counter}
									key={node.data.uniqueId}
									positionDisplay={displayCount}
									disabled={readonly || !node.data.isVisible}
									isBilateral={isBilateralQuestion}
									displayInstructionAsIcon={node.data.displayInstructionAsIcon}
									isBilateralFullInfo={getIsBilateralFullInfo(isBilateralQuestion, index)}
									uniqueKey={index}
									onQuestionValueChanged={(question, value, answer, category) => onQuestionValueChanged(instanceId, questionChanged, question, value, answer, category)}
								/>
							</Grid>
						))
					)
					break
				case 8:
					questionAboutToRender = (
						<Grid
							item
							xs={12}
						>
							<ReadonlyTextBlock
								data-testid="survey-container-readonly-text"
								question={node.data}
								position={counter}
								key={node.data.uniqueId}
								positionDisplay={displayCount}
								isBilateral={isBilateralQuestion}
							/>
						</Grid>
					)
					break
				case 1:
					questionAboutToRender = (
						nodes.map((node, index) => (
							<Grid
								item
								xs={getQuestionGridSize(isBilateralQuestion, index)}
								className={isBilateralQuestion ? 'bilateral-grid' : ''}
								style={{
									borderLeft: getBorderLeft(isBilateralQuestion, index),
									padding: getPadding(isBilateralQuestion, index)
								}}
							>
								<Field
									component={RadioSelectQuestion}
									data-testid="survey-container-radio-select"
									question={node.data}
									position={counter}
									key={node.data.uniqueId}
									positionDisplay={displayCount}
									disabled={readonly || !node.data.isVisible}
									isBilateral={isBilateralQuestion}
									displayInstructionAsIcon={node.data.displayInstructionAsIcon}
									isBilateralFullInfo={getIsBilateralFullInfo(isBilateralQuestion, index)}
									uniqueKey={index}
									onQuestionValueChanged={(question, value, answer, category) => onQuestionValueChanged(instanceId, questionChanged, question, value, answer, category)}
									name={`field.radio._${node.data.uniqueId}._${index}`}
								/>
							</Grid>
						))
					)
					break
				case 3:
					questionAboutToRender = (
						nodes.map((node, index) => (
							<Grid
								item
								xs={getQuestionGridSize(isBilateralQuestion, index)}
								className={isBilateralQuestion ? 'bilateral-grid' : ''}
								style={{
									borderLeft: getBorderLeft(isBilateralQuestion, index),
									padding: getPadding(isBilateralQuestion, index)
								}}
							>
								<GroupedQuestion
									data-testid="survey-container-grouped"
									question={node.data}
									key={node.data.uniqueId}
									position={counter}
									positionDisplay={displayCount}
									disabled={readonly || !node.data.isVisible}
									isBilateral={isBilateralQuestion}
									displayInstructionAsIcon={node.data.displayInstructionAsIcon}
									isBilateralFullInfo={getIsBilateralFullInfo(isBilateralQuestion, index)}
									uniqueKey={index}
									onQuestionValueChanged={(question, value, answer, category) => onQuestionValueChanged(instanceId, questionChanged, question, value, answer, category)}
								/>
							</Grid>
						))
					)
					break
				case 9:
					questionAboutToRender = (
						nodes.map((node, index) => (
							<Grid
								item
								xs={getQuestionGridSize(isBilateralQuestion, index)}
								className={isBilateralQuestion ? 'bilateral-grid' : ''}
								style={{
									borderLeft: getBorderLeft(isBilateralQuestion, index),
									padding: getPadding(isBilateralQuestion, index)
								}}
							>
								<Field
									component={AnalogQuestion}
									data-testid="survey-container-analog"
									question={node.data}
									position={counter}
									key={node.data.uniqueId}
									positionDisplay={displayCount}
									disabled={readonly || !node.data.isVisible}
									isBilateral={isBilateralQuestion}
									displayInstructionAsIcon={node.data.displayInstructionAsIcon}
									isBilateralFullInfo={getIsBilateralFullInfo(isBilateralQuestion, index)}
									uniqueKey={index}
									onQuestionValueChanged={
										(question, value, answer, category) =>
											onQuestionValueChanged(instanceId, questionChanged, question, value, answer, category)
									}
									name={`field.analog._${node.data.uniqueId}._${index}`}
								/>
							</Grid>
						))
					)
					break
				case 10:
				case 11:
					questionAboutToRender = (
						nodes.map((node, index) => {
							const validators = createValidators(node.data)

							return (
								<Grid
									item
									xs={getQuestionGridSize(isBilateralQuestion, index)}
									className={isBilateralQuestion ? 'bilateral-grid' : ''}
									style={{
										borderLeft: getBorderLeft(isBilateralQuestion, index),
										padding: getPadding(isBilateralQuestion, index)
									}}
								>
									<Field
										component={FileQuestion}
										data-testid="survey-container-file"
										question={node.data}
										position={counter}
										key={node.data.uniqueId}
										positionDisplay={displayCount}
										disabled={readonly || !node.data.isVisible}
										fieldValidators={validators}
										isOptional={node.data.isOptional}
										isBilateral={isBilateralQuestion}
										displayInstructionAsIcon={node.data.displayInstructionAsIcon}
										isBilateralFullInfo={getIsBilateralFullInfo(isBilateralQuestion, index)}
										uniqueKey={index}
									/>
								</Grid>
							)
						})
					)
					break
				default:
			}

			if (!!questionAboutToRender) {
				let questions = {}

				nodes.map(node => {
					questions[`question_${node.data.column}`] = node.data
				})

				let addBilateralTitleContainer = false

				if (renderBilateralAreaNames) {
					renderBilateralAreaNames = false
					
					isBilateralAreaNamesRendered = true

					addBilateralTitleContainer = true
				}

				rendered.push(
					<DelayedQuestionContainer
						key={node.data.uniqueId}
						container={
							<Fragment>
								{
									!!addBilateralTitleContainer
									&& <Grid
										container
										className={isBilateral ? 'bilateral-table' : ''} 
									>
										<Grid item xs={12} sm={4} />
										{
											bilateralAreas.map((area, index) => (
												<Grid
													item
													xs={6} sm={4}
													className="bilateral-table-head-wrap"
													style={{
														textAlign: "center",
														borderLeft: getBorderLeft(isBilateralQuestion, index),
														padding: "5px 10px"
													}}
												>
													<Typography
														variant='h3'
														className="bilateral-table-head"
														style={{
															fontWeight: 'bold', 
															fontSize: '18px', 
															textTransform: 'uppercase'
														}}
													>
														{ area }
													</Typography>
												</Grid>
											))
										}
									</Grid>
								}
								<Grid
									container
									className={isBilateralQuestion ? 'bilateral-container' : ''} 
								>
									{/* Bilateral questions except GroupedQuestion */}
									{
										!!isBilateralQuestion
										&& node.data.questionType !== 8
										&& node.data.questionType !== 3
										&& <Fragment>
											<Grid
												item
												xs={4}
												className="bilateral-container-title"
											>
												<BilateralQuestionInfo {...questions} />
											</Grid>
											<Grid
												item
												xs={8}
												className="bilateral-container-content-outer"
											>
												<Grid item container className="bilateral-container-content">
													{questionAboutToRender}
												</Grid>
											</Grid>
										</Fragment>
									}
									
									{/* Bilateral GroupedQuestion */}
									{
										!!isBilateralQuestion
										&& node.data.questionType !== 8
										&& node.data.questionType == 3
										&& <Fragment>
											<Grid
												item
												xs={12}
												className="bilateral-container-title bilateral-grouped"
											>
												<BilateralQuestionInfo {...questions} />
											</Grid>
											<Grid
												item
												xs={12}
												
											>
												<Grid item container className="bilateral-container-content bilateral-grouped">
													{questionAboutToRender}
												</Grid>
											</Grid>
										</Fragment>
									}
									{/* Bilateral Question Header */}
									{
										!!isBilateralQuestion
										&& node.data.questionType == 8
										&& <Fragment>
											{questionAboutToRender}
										</Fragment>
									}
									{/* Question Header */}
									{
										!isBilateralQuestion
										&& <Fragment>
											{questionAboutToRender}
										</Fragment>
									}
									
								</Grid>
							</Fragment>
						}
						{...questions}
					/>
				)
			}
		})
		return rendered
	}
}

export default ({
	instanceId,
	isBilateral,
	bilateralAreas,
	lists,
	collections,
	readonly = false
}) => {
    const [visibleCollection, setVisibleCollection] = useState([])
    const dispatch = useDispatch()

	const createNodesVisibilityLink = (parentNode, childNode, siblingChildNode) => {
		if (!childNode.data.parentVisibilityRefs.includes(parentNode)) {
			childNode.data.parentVisibilityRefs.push(parentNode)

			if (!!siblingChildNode) {
				siblingChildNode.data.parentVisibilityRefs.push(parentNode)
			}
		}

		if (!parentNode.data.childVisibilityRefs.includes(childNode)) {
			parentNode.data.childVisibilityRefs.push(childNode)

			if (!!siblingChildNode) {
				parentNode.data.childVisibilityRefs.push(siblingChildNode)
			}
		}
	}

	const createNodesOptionalLink = (parentNode, childNode, siblingChildNode) => {
		if (!childNode.data.parentOptionalRefs.includes(parentNode)) {
			childNode.data.parentOptionalRefs.push(parentNode)

			if (!!siblingChildNode) {
				siblingChildNode.data.parentOptionalRefs.push(parentNode)
			}
		}

		if (!parentNode.data.childOptionalRefs.includes(childNode)) {
			parentNode.data.childOptionalRefs.push(childNode)

			if (!!siblingChildNode) {
				parentNode.data.childOptionalRefs.push(siblingChildNode)
			}
		}
	}

    const initialize = () => {
        let newVisibleCollection = []

		collections
			.map((collection, index) => {
				let newCollection = []

				collection
					.map((node, nodeIndex) => {
						let isVisible = !node.data.isConditionalVisibility || !node.data.visibilityRule?.length
						let isOptional = node.data.isOptionalDefault ?? (!isVisible && !!node.data.isConditionalVisibility || node.data.isOptional)
		
						node.data.isVisible = isVisible
						node.data.changed = false
						node.data.parentChanged = false
		
						let name = null; 
	
						switch (node.data.questionType) {
							case 5:
								name = `answers.text._${node.data.uniqueId}._${index}`;
								break;
							case 6:
								name = `answers.number._${node.data.uniqueId}._${index}`;
								break;
							case 7:
								name = `answers.date._${node.data.uniqueId}._${index}`;
								break;
						}
				
						if (name) {
							_regexValidationMessages[name] = { value: node.data.regularExpression, message: node.data.regularExpressionValidation }
						}

						node.data.column = index
						node.data.isVisible = isVisible
						node.data.isOptionalDefault = node.data.isOptionalDefault ?? node.data.isOptional
						node.data.isOptional = isOptional
						node.data.parentVisibilityRefs = []
						node.data.childVisibilityRefs = []
						node.data.parentOptionalRefs = []
						node.data.childOptionalRefs = []
						node.data.context = getQuestionEvalContext(instanceId, node.data)
		
						if (
							index > 0
							&& !node.data.isBilateral
						) {
							return
						}
				
						if (!newVisibleCollection.length) {
							newCollection.push([ node ])
						}
						else {
							newVisibleCollection[nodeIndex].push(node)
						}
					})

				if (!!newCollection.length) {
					newVisibleCollection = newCollection
				}
			})

        newVisibleCollection
			.map((nodes, index) => {
				newVisibleCollection.map((childNodes, childIndex) => {
					nodes.map((_, side) => {
						if (index >= childIndex) {
							return
						}

						let node = nodes[side]

						let childNode = !!childNodes[side] ? childNodes[side] : childNodes[0]

						if (!childNode) {
							return
						}

						let siblingChildNode = nodes.length < childNodes.length ? childNodes[1] : null

						if (!!childNode.data.isConditionalVisibility) {
							let questionId = questionCode(instanceId, node.data.id, node.data.questionType)

							if (
								!!childNode.data.visibilityRule?.length
								|| !!childNode.data.optionalRule?.length
							) {
								if (!!node.data.categories?.length) {
									node.data.categories.map((category) => {
										let categoryId = categoryCode(node.data.id, category.id)
										
										if (
											!!childNode.data.visibilityRule?.length
											&& childNode.data.visibilityRule.includes(categoryId)
										) {
											createNodesVisibilityLink(node, childNode, siblingChildNode)
										}

										if (
											!!childNode.data.optionalRule?.length
											&& childNode.data.optionalRule.includes(categoryId)
										) {
											createNodesOptionalLink(node, childNode, siblingChildNode)
										}
									})
								}
								else {
									if (
										!!childNode.data.visibilityRule?.length
										&& childNode.data.visibilityRule.includes(questionId)
									) {
										createNodesVisibilityLink(node, childNode, siblingChildNode)
									}

									if (
										!!childNode.data.optionalRule?.length
										&& childNode.data.optionalRule.includes(questionId)
									) {
										createNodesOptionalLink(node, childNode, siblingChildNode)
									}
								}
							}
						}
					})
				})
			})

		newVisibleCollection
			.map((nodes) => {
				nodes.map(node => {
					if (node.data.isVisible) {
						checkQuestionRefs(node.data)
					}
				})
			})

		setVisibleCollection(newVisibleCollection)
    }

    // Initializing question collections
    useEffect(
        () => {
			if (
				!collections
				|| !instanceId
			) {
				return
			}

			if (!collections.filter(x => !!x && !!Object.keys(x).length).length) {
				return
			}

			initialize()
        },
        [ collections, instanceId ]
    )

	useEffect(
		() => {
			dispatch(stopSaving())
			setUploadingCount(0)
		},
		[]
	)
	
    const questionChanged = (question) => {
        if (checkQuestionRefs(question) > 0) {
			setVisibleCollection([...visibleCollection])
		}
    }

    const checkQuestionRefs = (question) => {
		let changes = 0

        for (let i = 0; i < question.childVisibilityRefs.length; i++) {
            changes += checkRef(question.childVisibilityRefs[i])
		}
		
        for (let i = 0; i < question.childOptionalRefs.length; i++) {
            let childNode = question.childOptionalRefs[i]
            if (!question.childVisibilityRefs.find(n => n.data.id === childNode.data.id && n.data.questionType === childNode.data.questionType)) {
                changes += checkRef(childNode)
            }
		}

		if (
			!!question.isConditionalVisibility
			&& question.parentOptionalRefs.length === 0
			&& !!question.optionalRule?.length
		) {
			let optionalResult = question.isBundle
            ? !question.isVisible || question.isOptionalDefault
            : !question.isVisible || question.isVisible && !!evalRule('', question.optionalRule)
			let changeOptional = question.isOptional !== optionalResult
			question.isOptional = optionalResult

			if (changeOptional) {
				changes += 1
			}
		}

		return changes
	}

	const buildContextAndEvalRule = (parentRefs, rule) => {
		let contexts = {}
		let isBilateralCondition = parentRefs.find(x => x.data.column === 1)
        parentRefs.map((parentNode) => {
			let column = parentNode.data.column
			
            if (parentNode.data.isVisible) {
				contexts[`${column}`] = (contexts[`${column}`] ?? '') + parentNode.data.context
			}
			else {
				contexts[`${column}`] = (contexts[`${column}`] ?? '') + getQuestionDefaultEvalContext(instanceId, parentNode.data)
			}

			//if unilateral question is included in bilateral condition, we need to change its column
			if(!parentNode.data.isBilateral && isBilateralCondition && column === 0) {
				column = 1

				if (parentNode.data.isVisible) {
					contexts[`${column}`] = (contexts[`${column}`] ?? '') + parentNode.data.context
				}
				else {
					contexts[`${column}`] = (contexts[`${column}`] ?? '') + getQuestionDefaultEvalContext(instanceId, parentNode.data)
				}
			}
        })

        let result = !!rule?.length
			? Object.keys(contexts).length > 0
				? Object.keys(contexts).map(key => {
					let result = !!evalRule(contexts[key], rule)
					return result
				})
					.includes(true)
				: !!evalRule('', rule)
			: true

		return result
	}

    const checkRef = (node) => {
		let parentChanged = false
        node.data.parentVisibilityRefs.map((parentNode) => {
			if (parentNode.data.changed || parentNode.data.parentChanged) {
				parentChanged = true
			}
        })

        let visibilityResult = buildContextAndEvalRule(node.data.parentVisibilityRefs, node.data.visibilityRule)

        let optionalResult = visibilityResult
			? !node.data.optionalRule?.length
				|| node.data.isBundle
				? !visibilityResult || node.data.isOptionalDefault
				: buildContextAndEvalRule(node.data.parentOptionalRefs, node.data.optionalRule)
			: true

		let changeVisibility = node.data.isVisible !== visibilityResult
		let changeOptional = node.data.isOptional !== optionalResult
		
		if (!visibilityResult || readonly) {
			node.data.visibilityDelay = 0
		}
		else if (changeVisibility) {
			node.data.visibilityDelay = DEFAULT_VISIBILITY_DELAY
		}
        node.data.isVisible = visibilityResult
        node.data.isOptional = optionalResult
        if (changeVisibility) {
			collections[node.data.column]
				.find((defaultNode) => {
					if (node.data.uniqueId === defaultNode.data.uniqueId) {
						defaultNode.data.isVisible = node.data.isVisible
						defaultNode.data.parentChanged = parentChanged
						return true
					}
					else {
						return false
					}
				})
			return checkQuestionRefs(node.data) + 1
		}
        if (changeOptional) {
			return 1
		}
		else {
			return 0
		}
	}
	
	return (
		<div>
			<Grid data-testid="survey-container">
				{
					visibleCollection.length > 0
						? (
							visibleCollection
							&& <div className="surveyBoxContainer" data-testid="survey-container-inner">
								{
									renderQuestions(
										visibleCollection,
										lists,
										instanceId,
										isBilateral,
										bilateralAreas,
										questionChanged,
										readonly
									)
								}
							</div>
						)
						: (
							<Grid style={{ padding: '32px', display: 'flex', justifyContent: 'center'}}>
								<CircularProgress data-testid="render-questions-progress" />
							</Grid>
						)
				}
			</Grid>
		</div>
	)
}
